import { render, staticRenderFns } from "./chevron-left.vue?vue&type=template&id=76a0b904&"
import script from "./chevron-left.vue?vue&type=script&lang=js&"
export * from "./chevron-left.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/icons/chevron-left.vue
// module id = 935
// module chunks = 0